import {UserService} from "../../services/UserService";
import {User} from "../../entities/User";
import {EditModel} from "./EditModel";
import { Company } from "../../entities/Company";
import { CompanyService } from "../../services/CompanyService";

export class EditUserModel extends EditModel<User> {
    $q:ng.IQService;
    entityId: number;
    companies: Company[];
    static $inject = ['$q', 'CompanyService', 'UserService'];
    constructor($q: ng.IQService, public companyService: CompanyService, public service: UserService) {
        super($q, service, User);
    }
    loadData(entityId:number):ng.IPromise<boolean>{
        var entityPromise:ng.IPromise<any> = null;
        this.entityId = entityId;
        if(entityId == null){
            var entity = new User();
            entityPromise = this.$q.when<User>(entity);
        }
        else{
            entityPromise = this.service.get(entityId);
        }
        return this.$q.all([entityPromise, this.companyService.getAll()]).then((data) => {
            this.entity = data[0];
            this.companies = data[1];
            return this.$q.when<boolean>(true);
        })
    }
    saveData():ng.IPromise<boolean>{
        if (this.entity.username == null || this.entity.username == "")
            return this.$q.reject("Username must be set");
        if (this.entity.companyID == null && this.entity.username != "superadmin")
            return this.$q.reject("Company must be set");
        if(this.entityId == null && this.entity.password == null)
            return this.$q.reject("Password must be set");
        else
            return super.saveData();
    }
}
